import { render, staticRenderFns } from "./AddonPicker.vue?vue&type=template&id=47f5ba8e&scoped=true&lang=pug&"
import script from "./AddonPicker.vue?vue&type=script&lang=js&"
export * from "./AddonPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f5ba8e",
  null
  
)

export default component.exports